// extracted by mini-css-extract-plugin
export default {"leave":"loader__leave__qSC35","leaveActive":"loader__leaveActive__WgHlJ"};